<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import EditSave from "@hitit/mbr/src/v7/component/Common/EditSave.svelte";
	import Items from "../component/Post/Items.svelte";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";
	import { GoBackButton } from "@hitit/new_ui";
	import DetailViewer from "../component/Post/DetailViewer.svelte";
	import SingleEditor, {
		type SaveDetail,
	} from "../component/Post/SingleEditor.svelte";
	//Utils
	import { PostManager } from "@hitit/mbr/src/v7/class/POST/PostManager";
	import { popup } from "@hitit/hub/src/v7/store";
	import { api, t, notifications } from "@hitit/hub/src/stores";
	//Types
	import type { PostDTO } from "@hitit/api";
	//Props
	//Constants
	//Variables
	let loading = false;
	let editmode = false;
	let selectedItem: PostDTO | null = null;
	let postManager: PostManager;
	//Functions
	async function actionHandler() {
		let phase = "";
		try {
			if (loading) return
			if (editmode === false) return (editmode = true);
			
			const { newly, updated, deleted } = postManager.getDTO_ToSend();
			loading = true;

			// Created
			for (const postDTO of newly) {
				phase = `상태 : 생성 <br/>,id:[${postDTO.id}]`;
				await $api.createPost_Document(postDTO);
			}
			// Update
			for (const postDTO of updated) {
				phase = `상태 : 수정 <br/>,id:[${postDTO.id}]`;
				await $api.updatePost_Document(postDTO.id || "", postDTO);
			}
			// Delete
			for (const postDTO of deleted) {
				phase = `상태 : 삭제 <br/>,id:[${postDTO.id}]`;
				await $api.deletePost_Document(postDTO.id || "");
			}

			init();
		} catch (error) {
			notifications.append(
				"ERROR",
				`실패<br/>${phase}`,
				"",
				undefined,
				"WARNING"
			);
			console.log(error);
		} finally {
			loading = false;
		}
	}

	function saveHandler(e: { detail: SaveDetail }) {
		const detail = e.detail;
		const id = e.detail.id;
		const isOrigin = postManager.postList.find((v) => v.id === id);
		
		if (isOrigin) {
			const updateDTO = Object.assign(isOrigin, { ...detail });
			postManager.updatePost(updateDTO);
		} else {
			postManager.addPost(detail);
		}
		postManager = postManager;
		selectedItem = null;
	}

	function itemClickHandler(e: { detail: string }) {
		const id = e.detail;
		postManager.getItem(id);
		selectedItem = postManager.getItem(id);
	}

	function newItemClickHandler(e: { detail: string }) {
		selectedItem = postManager.newItem();
	}

	function deletePost(id: string) {
		postManager.deletePost(id);
		postManager = postManager;
		selectedItem = null;
		$popup = undefined;
	}

	// function 

	function itemDeleteHandler(e: { detail: string }) {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: $t("mbr.setting.post_setting.delete"),
				accept: () => deletePost(e.detail),
				cancel: () => ($popup = undefined),
			},
		};
	}

	async function init() {
		loading = true;
		const { data } = await $api.getPost_DocumentList();
		postManager = new PostManager(data.postListDTOList);
		editmode = false;
		loading = false;
	}
	//Do

	$: mobileDisplayCondition = selectedItem !== null;
	$: init();
	
</script>

{#if loading}
	<ContainerLoading />
{/if}
{#if postManager}
	<div class="container">
		<div class="actions">
			<EditSave
				editmode={editmode}
				doneText={$t("mbr.setting.save_changes")}
				actionHandler={actionHandler}
				_static
			/>
		</div>
		<div class="items-detail">
			<div class="items-box">
				<Items
					items={postManager.postList}
					editmode={editmode}
					on:ITEM_CLICK={itemClickHandler}
					on:NEW_ITEM={newItemClickHandler}
					on:ITEM_DELETE={itemDeleteHandler}
				/>
			</div>
			<div
				class="detail-box"
				class:mobileDisplayCondition={mobileDisplayCondition}
			>
				<div class="goBack">
					<GoBackButton
						on:click={() => {
							selectedItem = null;
						}}
					/>
				</div>
				{#if !editmode && selectedItem !== null}
					<DetailViewer item={selectedItem} />
				{:else if editmode && selectedItem !== null}
					<SingleEditor item={selectedItem} on:SAVE={saveHandler} />
				{/if}
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	@import "../../variables.scss";
	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 20px;
		.actions {
			display: flex;
			flex-direction: row-reverse;
		}

		.items-detail {
			display: flex;
			flex-direction: column;
			width: 100%;
			gap: 20px;
			.items-box {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}

		.items {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}

		.detail-box {
			display: none;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			overflow-y: auto;
			background-color: #f0f0f4;
			padding: 70px 20px 20px 20px;
			box-sizing: border-box;
			&.mobileDisplayCondition {
				display: flex;
				flex-direction: column;
			}
			.goBack {
				width: 30px;
				height: 27px;
				position: absolute;
				top: 23.2px;
				right: 20px;
			}
		}
	}

	@include DesktopSize {
		.container {
			.actions {
			font-size: 1.25rem;
		}
			.items-detail {
				flex-direction: row;
				height: 800px;
				gap: 20px;
				.items-box {
					flex-basis: 950px;
					flex-grow: 1;
					min-width: 0;
					gap: 20px;
				}
				.detail-box {
					min-width: 500px;
					flex-basis: 622px;
					max-width: 622px;
					flex-grow: 1;
				}
			}

			.detail-box {
				padding: 0;
				display: flex;
				flex-direction: column;
				position: static;
				min-height: 0;
				max-height: none;
				flex-basis: calc(100% * (642 / 1594));
				max-width: 642px;
				/* temp debuging point */
				.goBack {
					display: none;
				}
			}
		}
	}
</style>
